import React, {useEffect} from "react";
import Helmet from "react-helmet";
import "../../styles/newStyles/HelpWidget.scss";
import {tenantId, chatBotId} from "config/envConfig";
import {useSelector} from "react-redux";


export const HelpWidget = () => {
  const user = useSelector((state) => state.login?.user);
  if (
    tenantId === "e7f81d33-0817-4c34-800d-b8b4ade36f2e" &&
    typeof window !== "undefined" &&
    user?.firstName
  ) {

    const botmakerVarScript = document.getElementById("botmaker-var-script");

    if (!botmakerVarScript) {
      const inlineScript = document.createElement("script");
      inlineScript.type = "text/javascript";
      inlineScript.id = "botmaker-var-script";
      inlineScript.innerHTML = `
        var BOTMAKER_VAR = {
          first_name: ${JSON.stringify(user.firstName)},
          last_name: ${JSON.stringify(user.lastName)},
          full_name: ${JSON.stringify(user.firstName + " " + user.lastName)},
          email: ${JSON.stringify(user.email)},
          user_uuid: ${JSON.stringify(user.uuid)},
          fiscal_id: ${JSON.stringify(user.fiscalId)},
          company_name: ${JSON.stringify(user.accountName)},
          channel: 'dashboard'
        };
      `;
      document.body.appendChild(inlineScript);
    }
  }

  let scriptElement;
  switch (tenantId) {
    case "e7f81d33-0817-4c34-800d-b8b4ade36f2e":
      scriptElement = (
        <script
          id="language-script"
          type="text/javascript"
          async
          src={`https://go.botmaker.com/rest/webchat/p/${chatBotId}/init.js`}
        ></script>
      );
      break;
    case "203c5d06-1f1b-49ef-ab38-71ed4d60db66":
      scriptElement = (
        <script
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=c341a8e0-577b-42a8-875c-67c1f7588eb2"
        ></script>
      );
      break;
    default:
      scriptElement = null;
  }

  return <div className="help-widget"><Helmet>{scriptElement}</Helmet></div>;
};
